import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { addDays, format } from 'date-fns';
import { vi } from 'date-fns/locale';

interface SuggestDatesProps {
  selectedDate: string | null;
  onDateSelect: (date: string | null) => void;
  className?: string;
}

export function SuggestDates({ selectedDate, onDateSelect, className = '' }: SuggestDatesProps) {
  const today = new Date();

  const suggestedDates = Array.from({ length: 7 }, (_, index) => {
    const date = addDays(today, index);
    const dateString = format(date, 'yyyy-MM-dd');

    let label: string;
    if (index === 0) {
      label = 'Hôm nay';
    } else if (index === 1) {
      label = 'Ngày mai';
    } else {
      label = format(date, 'EEEE, dd/MM', { locale: vi });
    }

    return { date: dateString, label };
  });

  return (
    <div className={`w-full ${className}`}>
      <div className="horizontal-scrollbar scrollbar-hide flex flex-wrap gap-2 overflow-x-auto pb-2">
        {suggestedDates.map((dateItem) => (
          <Button
            key={dateItem.date}
            variant={dateItem.date === selectedDate ? 'default' : 'outline'}
            onClick={() => onDateSelect(dateItem.date)}
            className={cn(
              'flex-shrink-0 rounded-full px-3 py-1 text-xs whitespace-nowrap transition-all duration-200 md:px-4 md:py-2 md:text-base',
              dateItem.date === selectedDate ? 'bg-primary text-white shadow-sm' : 'hover:bg-gray-50',
            )}
          >
            <div className="flex flex-col items-center">{dateItem.label}</div>
          </Button>
        ))}
        {/* "Tất cả các ngày" chip */}
        <Button
          variant={selectedDate === null ? 'default' : 'outline'}
          onClick={() => onDateSelect(null)}
          className={cn(
            'flex-shrink-0 rounded-full px-3 py-1 text-xs whitespace-nowrap transition-all duration-200 md:px-4 md:py-2 md:text-base',
            selectedDate === null ? 'bg-primary text-white shadow-sm' : 'hover:bg-gray-50',
          )}
        >
          Tất cả các ngày
        </Button>
      </div>
    </div>
  );
}
